export default __webpack_public_path__ + "static/media/fpm-bg.76745ba6.jpg";